import React from "react";
import { ModalSearchSignatureProps } from "./interface";
import { Signature } from "../../generated/graphql";
import DefaultModal from "../ModalDefault";
import TableSignature from "../TableSignature";

const ModalSearchSignature: React.FC<ModalSearchSignatureProps> = ({
  onSelect,
  ...props
}) => {
  return (
    <DefaultModal
      {...props}
      contentMaxW="1080px"
      title="Search Signature"
      hideFooter
    >
      <TableSignature
        tableContainerProps={{
          maxH: "calc(100vh - 280px)",
          overflow: "auto",
        }}
        columnVisibility={{
          isDefault: false,
          enable: false,
        }}
        activeOnly
        hasRowSelection
        onSelect={(signature) => {
          onSelect(signature as Signature);
        }}
      />
    </DefaultModal>
  );
};

export default ModalSearchSignature;
